<template>
	<pui-datatable :modelName="modelName" :externalFilter="externalFilter"></pui-datatable>
</template>

<script>
export default {
	name: 'PuiAuditGrid',
	data() {
		return {
			modelName: 'puiaudit',
			externalFilter: {
				groupOp: 'and',
				groups: [],
				rules: [ {
					field: 'model',
					op: 'in',
					data: 'login,logout'
				}]
			}
		};
	}
};
</script>
